import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';

dayjs.extend(localizedFormat);

export const getDate = (date) => {
    if(date){
        return dayjs(date).format('YYYY-MM-DD')
    } else {
        return null;
    }   
}